<template src="./index.html">
</template>

<script>
	import {getdata} from './data.js'
	import upprocess from '../../../../common/upProcess/index.vue'
	import uploadFile from '../../../../common/uploadFile/index.vue'
	import updateywkm from '../../../../common/updateywkm/index.vue'
	import config from '../../../../../../configHttp.js'
	export default{
		components:{
			upprocess,uploadFile,updateywkm
		},
		data:function(){
			return{
				uptype:1,
				importType:"0",
				mboptions:getdata().mboptions,
				
				// count: 5,
				// successCount:0,
				// successdata:{},
				// batchNum: "",
				// timer:null,
				upformdata: {}, //文件信息
			}
		},
		methods:{
			forbackup(){
				this.$refs['uploadfileRef'].forrefresh()
				this.uptype=1
				 clearInterval(this.timer);
			},
			forchooseindex(index){
					this.$emit("forchooseindex",index)
			},
			toCustomTemplate(){
				this.$router.push("/CustomTemplate")
			},
			getuploadparams(e){
				this.upformdata = e
				// 获取到的文件信息
			},
			fordownloadmb(){
				let params={
					downUrl:config.baseURL+"",
					typeObj:{
						toForm:false,
						fileName:"代扣代缴凭证标准模板"+ this.$timestampToStr(new Date(),'yyyyMMdd'),
						fileType:'xlsx',
					},
				}
				
				///
			},
			importIinvExcel(){
				if (this.$emptyandnull(this.upformdata.upfile)) {
					this.$message.error("请选择要上传的文件")
					return false
				}
				let formData = {
					importType: this.importType,
					file: this.upformdata.upfile
				};
			},
		}
	}
</script>

<style scoped lang="less">
	@import url("./index.less");
</style>